export default __webpack_public_path__ + "static/media/back-messages.aaf5867e.svg";